import React from 'react';
import { Entry } from 'contentful';
import { Divider } from 'antd';
import {
  ContentPageType,
  ContentSectionType,
  ContentSection,
  InfoBoxSection,
  HardCodedSection,
  HeaderSection,
  SubheaderSection
} from 'types/Content';
import ContentLayout from 'layouts/ContentLayout';
import InfoBoxBlock from 'pages/Homepage/InfoBoxBlock';
import ContentBlock from 'components/ContentBlock';
import HardCodedBlock from 'components/HardCodedBlock';
import subheaderStyles from './Subheader.module.scss';
import { useTranslation } from 'react-i18next';

export default function Content({ entry }: { entry: Entry<ContentPageType> }) {
  const {
    CONTENT_SECTION,
    INFOBOX_SECTION,
    HARDCODED_SECTION,
    HEADER_SECTION,
    SUBHEADER_SECTION
  } = ContentSectionType;

  const { subject, level } = entry.fields;
  const { t } = useTranslation()

  return (
    <ContentLayout>
      {entry.fields.sections.map((section: Entry<any>) => {
        const sectionType = section.sys.contentType.sys
          .id as ContentSectionType;

        switch (sectionType) {
          case CONTENT_SECTION: {
            return (
              <ContentBlock
                key={section.sys.id}
                section={section as Entry<ContentSection>}
              />
            );
          }
          case INFOBOX_SECTION: {
            return (
              <InfoBoxBlock
                key={section.sys.id}
                section={section as Entry<InfoBoxSection>}
              />
            );
          }

          case HARDCODED_SECTION: {
            return (
              <HardCodedBlock
                key={section.sys.id}
                subject={subject}
                level={level}
                section={section as Entry<HardCodedSection>}
              />
            );
          }
          case HEADER_SECTION: {
            const headerSection = section as Entry<HeaderSection>;
            return (
              <div key={section.sys.id}>
                <h1>{headerSection.fields.header}</h1>
                <Divider />
              </div>
            );
          }
          case SUBHEADER_SECTION: {
            const subheaderSection = section as Entry<SubheaderSection>;

            const {
              mainContainerStyle,
              centerStyle,
              subHeaderStyle
            } = subheaderStyles;

            return (
              <div className={mainContainerStyle} key={section.sys.id}>
                <div className={centerStyle}>
                  <p className={subHeaderStyle} key={section.sys.id}>
                    {subheaderSection.fields.subheader}
                  </p>
                  <Divider />
                </div>
              </div>
            );
          }
          default:
            return (
              <h1
                key={section.sys.id}
                style={{ backgroundColor: 'red', height: '40px' }}
              >
                {t('UNIMPLEMENTED')}: {sectionType}
              </h1>
            );
        }
      })}
    </ContentLayout>
  );
}
